import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ReplaySubject } from "rxjs";
import * as _ from "lodash";
import { CurrencyService } from "services/currency/CurrencyService";
import { I18NService } from "services/i18n/I18NService";
import { projectsI18N } from "../../i18n/projects-i18n";
import { ProjectPricing } from "models/projects/ProjectPricing";

@Component({
    selector: "project-fixed-rate-pricing",
    templateUrl: "project-fixed-rate-pricing.html",
})
export class ProjectFixedRatePricingComponent implements OnInit {
    @Input() public currentPricing: ProjectPricing;
    @Input() public noInitialPricing: boolean;
    @Output() public valid = new EventEmitter<boolean>();
    @Output() public newPricing = new EventEmitter<ProjectPricing>();
    public rateValid: boolean;
    public workloadValid: boolean;
    public rateTouch = false;
    public workloadTouch = false;
    public i18n;
    private pricing: ProjectPricing;
    public currenciesArray: Array<CurrencyOption>;

    public selected = new ReplaySubject<CurrencyOption[]>(1);
    public preselected = new ReplaySubject<CurrencyOption[]>(1);

    constructor(
        i18nService: I18NService,
        private currencyService: CurrencyService
    ) {
        this.i18n = i18nService.extractCurrentTranslation(projectsI18N);
        const currencies = currencyService.getSupportedCurrencies();
        const currenciesArray = [];
        currencies.forEach(function (name) {
            currenciesArray.push({ name: name, id: name });
        });
        this.currenciesArray = currenciesArray;
    }

    public ngOnInit() {
        this.pricing = _.cloneDeep(this.currentPricing);
        this.rateValid = !!this.pricing.rate;
        this.workloadValid = !!this.pricing.expectedWorkload;

        const preselected = [
            { name: this.pricing.currency, id: this.pricing.currency },
        ];
        this.preselected.next(preselected);

        this.selected.subscribe((selectedOptions) => {
            if (selectedOptions[0]) {
                this.setCurrency(selectedOptions[0].id);
                this.currentPricing.currency = selectedOptions[0].id;
            }
        });
    }

    public setRate(rate: string) {
        const isValid = this.currencyService.isFormatValid(rate);
        this.rateTouch = true;
        this.rateValid = isValid;
        if (isValid) {
            this.pricing.rate = this.currencyService.convertToNumber(rate);
            this.newPricing.next(this.pricing);
        }
        this.emitValidationEvent();
    }

    public setCurrency(currency: string) {
        this.pricing.currency = currency;
        this.newPricing.next(this.pricing);
        this.emitValidationEvent();
    }

    public setExpectedWorkload(workloadStr: string) {
        const workload = parseInt(workloadStr, 10);
        this.workloadTouch = true;
        if (!_.isNaN(workload) && workload > 0) {
            this.pricing.expectedWorkload = workload;
            this.newPricing.next(this.pricing);
            this.workloadValid = true;
        } else {
            this.workloadValid = false;
        }
        this.emitValidationEvent();
    }

    private emitValidationEvent() {
        this.valid.next(
            this.rateValid && this.workloadValid && !!this.pricing.currency
        );
    }
}

export type CurrencyOption = { name: string; id: string };
